
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hotels/reviews",
      function () {
        return require("private-next-pages/hotels/reviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hotels/reviews"])
      });
    }
  